import { Pipe, PipeTransform } from '@angular/core';
import { ChannelViewOption, TrendGraphView } from 'ops/common/models/trend-graph-view';

@Pipe({
    name: 'filterTrendGraph',
    standalone: false
})
export class filterTrendGraph implements PipeTransform {
    transform(trendGraphsViews: TrendGraphView[], searchCondition: string) {
        if (!searchCondition) {
            return trendGraphsViews;
        } else {
            console.log(trendGraphsViews);
            console.log(searchCondition);
            let result = trendGraphsViews.filter((view: TrendGraphView) => {
                let hasMetCondition = false;
                if (view.name.includes(searchCondition)) {
                    hasMetCondition = true;
                } else {
                    view.channels.map((channel: ChannelViewOption) => {
                        const stringChannelFcuId = channel.fcuChannelId.toString();
                        if (
                            stringChannelFcuId.includes(searchCondition) ||
                            channel.name?.includes(searchCondition)
                        ) {
                            hasMetCondition = true;
                        }
                    });
                }
                return hasMetCondition;
            });
            return result;
        }
    }
}
